<script>
import {Message} from "element-ui";
import { deletePermissionById, pagePermission, saveOrUpdatePermission} from "@/api/user";

export default {
  name: 'Permission',
  props: {
    roleId : {
      type: String |  Number,
      default: null
    }
  },
  data() {
    return {
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      permissionList: [],
      visible: false,
      permission: {},
      submitLoading: false,
      searchKeyword: '',
      rules: {
        permissionType : [
            { required: true, message: '请选择权限类型',trigger:'change' }
        ]
      }
    }
  },
  mounted() {

  },
  watch : {
    roleId : {
      handler(newValue, oldValue) {
        this.roleId = newValue
        if (newValue === oldValue) return;
        this.fetchPermissionList()
      }
    }
  },
  methods: {

    openEditDrawer() {
      if (this.permission.id) {
        this.permission = {}
      }
      this.visible = !this.visible;
    },

    async fetchPermissionList() {
      try {
        const params = {
          current: this.currentPage,
          size: this.pageSize,
          filter: [],
          sorted: [{
            name: 'createTime',
            type: 'DESC'
          }]
        }
        if (this.searchKeyword) {
          params.filter.push({
            name: 'tableName',
            type: 'LIKE',
            value: this.searchKeyword
          })
        }
        if (this.roleId){
          params.filter.push({
            name: 'roleId',
            type: 'EQ',
            value: this.roleId
          })
        }

        const resp = await pagePermission(params);
        this.permissionList = resp.result.records || [];
        this.total = resp.result.total;
      } catch (e) {
        console.log(e)
        this.permissionList = []; // 确保有默认空数组
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchPermissionList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchPermissionList()
    },

    async submitPermission() {
      this.submitLoading = true;
      this.$refs.permissionFormRef.validate(async valid => {
        if (valid){
          try {
            const param = {
              ...this.permission,
              roleId : this.roleId
            }
            if (param.permissionType === 'CUSTOM'){
              if (!param.matchType || !param.value){
                Message.error("当前为自定义类型，请补全匹配类型以及匹配值")
                return;
              }
            }
            const res = await saveOrUpdatePermission(param);
            if (res && res.code === "0000") {
              Message.success(`操作${res.result ? '成功' : '失败'}`);
            }
          } catch (e) {
            Message.error('操作失败');
          } finally {
            this.submitLoading = false;
          }

          this.cleanPermission();
          this.fetchPermissionList();
          this.$refs.editDrawer.closeDrawer()
        }
      })
    },

    async deletePermission(id) {
      this.$confirm('此操作将永久删除该权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        try {
          deletePermissionById(id).then( res => {
            if (res && res.code === "0000") {
              Message.success(`删除成功`);
              this.cleanPermission();
              this.fetchPermissionList();
            }
          })
        } catch (e) {
          Message.error('删除失败');
        }
      }).catch(() => {

      });

    },

    handleEdit(item) {
      this.permission = {
        ...item
      }
      this.visible = true

    },

    cleanPermission() {
      this.permission = {}
      this.currentPage = 1
    },

    handleSearch() {
      this.cleanPermission();
      this.fetchPermissionList()
    },

  },
}
</script>

<template>
  <div>
    <div v-if="roleId">
      <div style="width: 100%;display: flex; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 16px;">
          <!-- 搜索区域 -->
          <div class="filter-bar">
            <el-input size="small" v-model="searchKeyword" placeholder="搜索表名" clearable class="search-input" @keyup.enter="handleSearch">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </div>
        </div>
        <el-button type="text"   @click="openEditDrawer">新增权限</el-button>
      </div>

      <el-table :data="permissionList" border class="device-table" stripe highlight-current-row row-key="id">
        <el-table-column prop="tableName" label="表名" min-width="80" show-overflow-tooltip/>
        <el-table-column prop="tableColumn" label="列名" min-width="80" show-overflow-tooltip/>
        <el-table-column prop="permissionTypeDesc" label="权限类型"/>
        <el-table-column prop="matchTypeDesc" label="匹配类型"/>
        <el-table-column prop="value" label="匹配值" min-width="80" show-overflow-tooltip/>
        <el-table-column prop="createTime" label="创建时间" min-width="120" show-overflow-tooltip />

        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="text" @click="deletePermission(scope.row.id)" style="color: red">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"
                       class="pagination"></el-pagination>
      </div>
    </div>
    <div v-else style="flex: 1 ;">
      <el-empty description="请选择角色查询数据权限" />
    </div>

    <el-drawer
        :title="permission.id ? '编辑权限': '新增权限'"
        :visible.sync="visible"
        direction="rtl"
        ref="editDrawer"
    >
      <div class="permission-edit-container">
        <el-form ref="permissionFormRef" :model="permission" label-width="100px" :rules="rules">
          <el-form-item label="权限类型" prop="permissionType">
            <el-select v-model="permission.permissionType" placeholder="请选择权限类型" clearable style="width: 100%">
              <el-option label="系统预设" value="DEFAULT" />
              <el-option label="用户自定义" value="CUSTOM" />
            </el-select>
          </el-form-item>
          <el-form-item label="预设值" prop="fillType" v-if="permission.permissionType === 'DEFAULT'">
            <el-select v-model="permission.fillType" placeholder="请选择预设类型" clearable style="width: 100%">
              <el-option label="企业id" value="OFFICE" />
            </el-select>
          </el-form-item>
          <el-form-item label="表名" prop="tableName">
            <el-input v-model="permission.tableName" clearable/>
          </el-form-item>
          <el-form-item label="列名" prop="tableColumn">
            <el-input v-model="permission.tableColumn" clearable/>
          </el-form-item>
          <el-form-item label="匹配类型" v-if="permission.permissionType === 'CUSTOM'">
            <el-select v-model="permission.matchType" placeholder="请选择匹配类型" clearable style="width: 100%">
              <el-option label="等于" value="EQ"></el-option>
              <el-option label="不等于" value="NE"></el-option>
              <el-option label="包含" value="IN"></el-option>
              <el-option label="不包含" value="NOT_IN"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="匹配值" v-if="permission.permissionType === 'CUSTOM'">
            <el-input v-model="permission.value" clearable >
              <div slot="suffix">
                <el-tooltip effect="dark" content="多个可以用逗号(,)拼接" placement="bottom">
                  <i class="el-icon-question" style="width: 16px; height: 16px ;margin-right: 12px ; color : #e6a23c" />
                </el-tooltip>
              </div>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="permission-edit-footer">
          <el-button @click="$refs.editDrawer.closeDrawer()">取 消</el-button>
          <el-button type="primary" @click="submitPermission" :loading="submitLoading">
            {{ submitLoading ? '提交中 ...' : '提 交' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>

</template>

<style scoped>

.permission-edit-container {
  display: flex;
  flex-direction: column;
  padding: 12px;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.permission-edit-footer {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 12px;
  box-sizing: border-box;
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  align-items: center;
}

.search-input {
  width: 200px;
}


/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}


</style>
